import { createElement, forwardRef } from "react";
import Center_module from "./Center.module.js";
import { combineClasses } from "../../utilities/combineClasses.js";
import { theme } from "../../theme/index.js";
const Center = /*#__PURE__*/ forwardRef(({ maxWidth = '1200', centerText = false, padding, centerChildren = false, as = 'div', id, className, style, children, width, minWidth, height, minHeight, maxHeight, overflow, overflowX, overflowY, tabIndex, testId, role, onClick, onScroll, onDoubleClick, onMouseEnter, onMouseLeave, onMouseDown, onMouseUp, onKeyDown, ...rest }, ref)=>{
    const paddingStyle = padding ? {
        paddingLeft: theme.spacing[padding],
        paddingRight: theme.spacing[padding]
    } : {};
    return /*#__PURE__*/ createElement(as, {
        id,
        ref,
        className: combineClasses(className, Center_module.center, centerText ? Center_module.centerText : '', centerChildren ? Center_module.centerChildren : ''),
        style: {
            width,
            minWidth,
            height,
            minHeight,
            maxHeight,
            overflow,
            overflowX,
            overflowY,
            ...style,
            maxWidth: theme.sizing[maxWidth],
            ...paddingStyle
        },
        tabIndex,
        role,
        'data-testid': testId,
        onScroll,
        onClick,
        onDoubleClick,
        onMouseEnter,
        onMouseLeave,
        onMouseDown,
        onMouseUp,
        onKeyDown,
        ...rest
    }, children);
});
Center.displayName = 'Center';
export { Center };
